<template>
  <div class="titleBar">
    <div class="siteTitleSvg"></div>
    <div class="subTitle">Listen <a class='link' href="https://www.youtube.com/channel/UC16NwL1j35gxppTzZXztYXQ">here</a> to my EP "Trust and let go"</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.titleBar, a {
  color: rgb(230, 230, 230);
}
.siteTitle {
  font-family: Roboto, sans-serif;
  font-weight: 300;
  font-size: 83px;
}

.siteTitleSvg {
  height: 100px;
  /* width: 500px; */
  margin: 20px 0;

  background-image: url("../assets/yazzkimo-white.png");
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
}

.subTitle {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  font-size: 30px;
}

a {
  text-decoration: none;
  font-weight: 600;
}

a:hover {
  text-decoration: underline;
}

@media only screen and (max-width: 600px) {
  .siteTitle {
    font-size: 43px;
  }

  .subTitle {
    font-size: 13px;
  }

  .siteTitleSvg {
    height: 40px;
  }
}
</style>
